import { gql, useMutation } from '@apollo/client';
import { Employee, EMPLOYEE_FIELDS } from '@dieterApi/user/useUserQuery';

const UPDATE_EMPLOYEE = gql`
  ${EMPLOYEE_FIELDS}
  mutation updateEmployee($employeeId: String!, $name: String, $email: String) {
    updateEmployee(employeeId: $employeeId, name: $name, email: $email) {
      ...UserEmployeeFields
    }
  }
`;

export interface UpdateEmployeeResult {
  updateEmployee: Employee;
}

export interface UpdateEmployeeInput {
  employeeId: string;
  name?: string;
  email?: string | null;
}

export interface UpdateEmployeeContext {
  companyId: string;
}

export function useEmployeeUpdateMutation() {
  return useMutation<UpdateEmployeeResult, UpdateEmployeeInput, UpdateEmployeeContext>(UPDATE_EMPLOYEE, {
    update(cache, { data }) {
      if (!data?.updateEmployee) {
        return;
      }

      // Write the updated employee to the cache
      cache.writeFragment({
        id: `Employee:${data.updateEmployee.id}`,
        fragment: EMPLOYEE_FIELDS,
        data: data.updateEmployee,
      });
    },
  });
}
